import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PURGE } from "redux-persist";
import apiInstance from '../../../../api';
import { message } from 'antd';

export const getNews = createAsyncThunk(
  'kitchenDashboard/getNews',
  async (data, { rejectWithValue }) => {
    const api = '/news-admin/get?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data.newsAdmin;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Что то пошло не так');
    }
  }
);

export const createNews = createAsyncThunk(
  'kitchenDashboard/createNews',
  async (data, { rejectWithValue }) => {
    const api = '/news-admin/create?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Что то пошло не так');
    }
  }
);

export const updateNews = createAsyncThunk(
  'kitchenDashboard/updateNews',
  async (data, { rejectWithValue }) => {
    const api = '/news-admin/update?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Что то пошло не так');
    }
  }
);

export const deleteNews = createAsyncThunk(
  'kitchenDashboard/deleteNews',
  async (data, { rejectWithValue }) => {
    const api = '/news-admin/delete?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Что то пошло не так');
    }
  }
);

export const getProductsStatistics = createAsyncThunk(
  'kitchenDashboard/getProductsStatistics',
  async (data, { rejectWithValue }) => {
    const api = '/dashboard/getProductsStatistics?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data.productsStatistics;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Что то пошло не так');
    }
  }
);

export const getReviews = createAsyncThunk(
  'kitchenDashboard/getReviews',
  async (data, { rejectWithValue }) => {
    const api = '/dashboard/getReviews?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Что то пошло не так');
    }
  }
);

export const getPopularProducts = createAsyncThunk(
  'kitchenDashboard/getPopularProducts',
  async (data, { rejectWithValue }) => {
    const api = '/dashboard/getPopularProducts?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Что то пошло не так');
    }
  }
);

export const getCalendarMenu = createAsyncThunk(
  'kitchenDashboard/getCalendarMenu',
  async (data, { rejectWithValue }) => {
    const api = '/dashboard/getCalendarMenuPublication?XDEBUG_SESSION_START=MyVSCode';
    
    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data.calendarMenu;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Что то пошло не так');
    }
  }
);

export const checkPublishedMenu = createAsyncThunk(
  'kitchenDashboard/checkPublishedMenu',
  async (data, { rejectWithValue }) => {
    const api = '/dashboard/getCalendarMenuPublication?XDEBUG_SESSION_START=MyVSCode';
    
    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result && response.data.data.calendarMenu[0].races.length > 0) {
        return response.data.data.calendarMenu[0].races;
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Что то пошло не так');
    }
  }
);

export const checkAcceptanceCertificate = createAsyncThunk(
  'kitchenDashboard/checkAcceptanceCertificate',
  async (data, { rejectWithValue }) => {
    const api = '/dashboard/getCalendarMenuPublication?XDEBUG_SESSION_START=MyVSCode';
// data = {kitchenId: selectKitchen.id, deliveryDays: dateRange}
    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data.calendarMenu;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Что то пошло не так');
    }
  }
);

export const whoIsAssignedToDeliver = createAsyncThunk(
  'kitchenDashboard/whoIsAssignedToDeliver',
  async (data, { rejectWithValue }) => {
    const api = '/documents/checklist/getKitchenCourierAssignment?XDEBUG_SESSION_START=MyVSCode';
    
    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Что то пошло не так');
    }
  }
);

export const getOrderForAssembly = createAsyncThunk(
  'kitchenDashboard/getOrderForAssembly',
  async (data, { rejectWithValue }) => {
    const api = '/documents/getOrderForAssembly?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }), {
        responseType: 'blob'
      });

      // Проверяем Content-Type чтобы понять что вернул сервер
      const contentType = response.headers['content-type'] || response.headers['Content-Type'];
      
      if (contentType && contentType.includes('application/json')) {
        // Сервер вернул JSON (скорее всего ошибку), нужно его распарсить
        const text = await response.data.text();
        const errorData = JSON.parse(text);
        const errorMessage = errorData.data.message || 'Ошибка получения message от сервера';
        message.error(errorMessage);
        return rejectWithValue(errorMessage);
      }

      if (response.data) {
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        
        return blob;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      if (error.response && error.response.data instanceof Blob) {
        try {
          const blob = error.response.data;
          const text = await blob.text();
          let mes;

          try {
            const parsed = JSON.parse(text);
            mes = parsed.message || parsed.error || 'Неизвестная ошибка';
            message.error(mes)
          } catch {
            mes = text || 'Ошибка получения данных';
            message.error(mes)
          }

          return rejectWithValue(message);
        } catch (readError) {
          console.error('Ошибка чтения blob:', readError);
          return rejectWithValue('Ошибка при обработке ответа сервера');
        }
      }

      // Обычные сетевые ошибки или CORS
      const errorMessage = error.message || 'Ошибка сети или CORS';
      return rejectWithValue(errorMessage);
    }
  }
);

export const getAcceptanceCertificate = createAsyncThunk(
  'kitchenDashboard/getAcceptanceCertificate',
  async (data, { rejectWithValue }) => {
    const api = '/documents/getAcceptanceCertificate?XDEBUG_SESSION_START=MyVSCode';
    console.log(data, 'data for acceptance')
    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }), {
        responseType: 'blob'
      });

      // Проверяем Content-Type чтобы понять что вернул сервер
      const contentType = response.headers['content-type'] || response.headers['Content-Type'];

      if (contentType && contentType.includes('application/json')) {
        // Сервер вернул JSON (скорее всего ошибку), нужно его распарсить
        const text = await response.data.text();
        const errorData = JSON.parse(text);
        const errorMessage = errorData.data.message || 'Ошибка получения message от сервера';
        message.error(errorMessage);
        return rejectWithValue(errorMessage);
      }

      if (response.data) {
        const blob = new Blob([response.data], {
          type: 'application/pdf'
        });
        
        return blob;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      if (error.response && error.response.data instanceof Blob) {
        try {
          const blob = error.response.data;
          const text = await blob.text();
          let mes;

          try {
            const parsed = JSON.parse(text);
            mes = parsed.message || parsed.error || 'Неизвестная ошибка';
            message.error(mes)
          } catch {
            mes = text || 'Ошибка получения данных';
            message.error(mes)
          }

          return rejectWithValue(message);
        } catch (readError) {
          console.error('Ошибка чтения blob:', readError);
          return rejectWithValue('Ошибка при обработке ответа сервера');
        }
      }

      // Обычные сетевые ошибки или CORS
      const errorMessage = error.message || 'Ошибка сети или CORS';
      return rejectWithValue(errorMessage);
    }
  }
);

const initialState = {
  //News
  newsGetRequestStatus: null,
  newsCreateRequestStatus: null,
  newsUpdateRequestStatus: null,
  newsDeleteRequestStatus: null,
  productsStatisticsGetRequestStatus: null,
  reviewsGetRequestStatus: null,
  popularProductsGetRequestStatus: null,
  calendarMenuGetRequestStatus: null,

  news: [],
  productsStatistics: [],
  reviews: null,
  popularProducts: null,
  calendarMenu: [],
  calendarSlideIndex: 1, // Позиция слайда календаря
};

const kitchenDashboardSlice = createSlice({
  name: 'kitchenDashboard',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getNews.pending, (state) => {
        state.newsGetRequestStatus = 'pending';
      })
      .addCase(getNews.fulfilled, (state, action) => {
        state.newsGetRequestStatus = 'resolved';
        state.news = Array.isArray(action.payload) ? [...action.payload].reverse() : [];
      })
      .addCase(getNews.rejected, (state) => {
        state.newsGetRequestStatus = 'rejected';
      })
      .addCase(createNews.pending, (state) => {
        state.newsCreateRequestStatus = 'pending';
      })
      .addCase(createNews.fulfilled, (state) => {
        state.newsCreateRequestStatus = 'resolved';
      })
      .addCase(createNews.rejected, (state) => {
        state.newsCreateRequestStatus = 'rejected';
      })
      .addCase(updateNews.pending, (state) => {
        state.newsUpdateRequestStatus = 'pending';
      })
      .addCase(updateNews.fulfilled, (state) => {
        state.newsUpdateRequestStatus = 'resolved';
      })
      .addCase(updateNews.rejected, (state) => {
        state.newsUpdateRequestStatus = 'rejected';
      })
      .addCase(deleteNews.pending, (state) => {
        state.newsDeleteRequestStatus = 'pending';
      })
      .addCase(deleteNews.fulfilled, (state) => {
        state.newsDeleteRequestStatus = 'resolved';
      })
      .addCase(deleteNews.rejected, (state) => {
        state.newsDeleteRequestStatus = 'rejected';
      })
      .addCase(getProductsStatistics.pending, (state) => {
        state.productsStatisticsGetRequestStatus = 'pending';
      })
      .addCase(getProductsStatistics.fulfilled, (state, action) => {
        state.productsStatisticsGetRequestStatus = 'resolved';
        state.productsStatistics = action.payload;
      })
      .addCase(getProductsStatistics.rejected, (state) => {
        state.productsStatisticsGetRequestStatus = 'rejected';
      })
      .addCase(getReviews.pending, (state) => {
        state.reviewsGetRequestStatus = 'pending';
      })
      .addCase(getReviews.fulfilled, (state, action) => {
        state.reviewsGetRequestStatus = 'resolved';
        state.reviews = action.payload;
      })
      .addCase(getReviews.rejected, (state) => {
        state.reviewsGetRequestStatus = 'rejected';
      })
      .addCase(getPopularProducts.pending, (state) => {
        state.popularProductsGetRequestStatus = 'pending';
      })
      .addCase(getPopularProducts.fulfilled, (state, action) => {
        state.popularProductsGetRequestStatus = 'resolved';
        state.popularProducts = action.payload;
      })
      .addCase(getPopularProducts.rejected, (state) => {
        state.popularProductsGetRequestStatus = 'rejected';
      })
      .addCase(getCalendarMenu.pending, (state) => {
        state.calendarMenuGetRequestStatus = 'pending';
      })
      .addCase(getCalendarMenu.fulfilled, (state, action) => {
        state.calendarMenuGetRequestStatus = 'resolved';
        state.calendarMenu = action.payload;
      })
      .addCase(getCalendarMenu.rejected, (state) => {
        state.calendarMenuGetRequestStatus = 'rejected';
      })
      .addCase(PURGE, () => {
        return initialState;
      })
  },
  reducers: {
    setCalendarSlideIndex: (state, action) => {
      state.calendarSlideIndex = action.payload;
    },
  },
});

export const { setCalendarSlideIndex } = kitchenDashboardSlice.actions;

export default kitchenDashboardSlice.reducer;
